module.exports = __webpack_public_path__ + "media/images/i3learnhub-packflow-registrationcard-ea3c42e759664c634b543161f0c35a3a.png";